<template>
  <!-- Botón de menú visible solo en mobile -->
<div class="d-md-none mb-2">
  <button class="btn btn-primary w-100 mb-3" @click="menuVisible = !menuVisible">
    Menú de opciones
  </button>
</div>
<div class="row">
  <div class="col-12">
    <h4 class="p-3 mb-2 pt-0 text-blue fw-light fst-italic text-start">Historia Clínica:</h4>
  </div>
  <!-- Menú lateral: visible siempre en desktop, condicional en mobile -->
  <div :class="['col-md-3', 'mb-3', { 'd-none': !menuVisible && isMobile }]" ref="menuColumn">
    <div class="list-group">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        type="button"
        :class="['list-group-item list-group-item-action', { active: activeTab === tab.name }]"
        @click="selectTab(tab.name)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>

  <!-- Contenido -->
  <div class="col-12 col-md-9">
    <div class="tab-content">
      <tab-personal-background v-if="activeTab == 'PersonalBackground'" :userId="userId" :consId="consId" />
      <tab-familiar-background v-if="activeTab == 'FamilyBackground'" :userId="userId" :consId="consId" />
      <tab-consultation-reason v-if="activeTab == 'ConsultationReason'" :userId="userId" :consId="consId" />
      <tab-sessions v-if="activeTab == 'Sessions'" :userId="userId" :consId="consId" />
      <tab-studies v-if="activeTab == 'Studies'" :userId="userId" :consId="consId" />
      <tab-treatments v-if="activeTab == 'Treatments'" :userId="userId" :consId="consId" />
      <tab-consent v-if="activeTab == 'Consents'" :userId="userId" :consId="consId" />
      <tab-allergies v-if="activeTab == 'Allergies'" :userId="userId" :consId="consId" />
      <tab-vaccines v-if="activeTab == 'Vaccines'" :userId="userId" :consId="consId" />
    </div>
  </div>
</div>
</template>

<script>
import tabPersonalBackground from '@/components/clients/history/tab-personal-background.vue'
import tabFamiliarBackground from '@/components/clients/history/tab-familiar-background.vue'
import tabConsultationReason from '@/components/clients/history/tab-consultation-reason.vue'
import tabSessions from '@/components/clients/history/tab-sessions.vue'
import tabStudies from '@/components/clients/history/tab-studies.vue'
import tabTreatments from '@/components/clients/history/tab-treatments.vue'
import tabConsent from '@/components/clients/history/tab-consent.vue'
import tabAllergies from '@/components/clients/history/tab-allergies.vue'
import tabVaccines from '@/components/clients/history/tab-vaccines.vue'
export default {
  name: 'PatientHistoryTabs',
  props: ['userId', 'consId'],
  components: {   
      tabPersonalBackground,
      tabFamiliarBackground,
      tabConsultationReason,
      tabSessions,
      tabStudies,
      tabTreatments,
      tabConsent,
      tabAllergies,
      tabVaccines 
  },
  data() {
    return {
      activeTab: 'ConsultationReason',
      menuVisible: false,
      tabs: [
        { name: 'ConsultationReason', label: 'Motivo de consulta' },
        { name: 'Sessions', label: 'Consulta y evolución' },
        { name: 'Treatments', label: 'Tratamientos' },
        { name: 'Studies', label: 'Estudios' },
        { name: 'Allergies', label: 'Alergias' },
        { name: 'PersonalBackground', label: 'Antecedentes personales' },
        { name: 'FamilyBackground', label: 'Antecedentes familiares' },
        { name: 'Vaccines', label: 'Vacunas' },
        { name: 'Consents', label: 'Consentimientos' }
      ]
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768
    },
    activeTabComponent() {
      return `Tab${this.activeTab}`;
    }
  },
  methods: {
  selectTab(tabName) {
    this.activeTab = tabName
    if (this.isMobile) {
      this.menuVisible = false
    }
  }
}
};
</script>

<style scoped>
.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #1c56b7 ;
    border-color: #1c56b7;
}
</style>